import React from 'react'

function Footer() {
    return (
			<div className='footer'>
				<a href='https://github.com/pushpjain3/Fun-with-Triangles.git' className='link'>
					<i className='fab fa-github' />
				</a>

				<a href='https://pushpjain.netlify.app/' className='link'>
					pushpjain
				</a>
			</div>
		);
}

export default Footer
